import { render, staticRenderFns } from "./CardCreateSlugSuccess.vue?vue&type=template&id=de118ed4&scoped=true&"
import script from "./CardCreateSlugSuccess.vue?vue&type=script&lang=js&"
export * from "./CardCreateSlugSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de118ed4",
  null
  
)

export default component.exports